import { GiganetCustomerData, CustomerData, CustomerDBStatus, CustomersBySerial } from '@ip6m/types';
import { Injectable, Logger } from '@nestjs/common';
import { Timeout } from '@nestjs/schedule';

import { PgService } from './pg.service';

@Injectable()
export class AppService {

  constructor(private pgService: PgService){}

  /*
   * Just for testing
   *
  @Timeout(1000)
  test() {
    this.getData('485754432C837166');    
    this.getData();
  }
  */

  getDBStatus(): CustomerDBStatus {
    return this.pgService.getDBStatus();
  }

  getData(sn: string):CustomersBySerial {
    let resp: CustomersBySerial = {};
    try {
      const custDB:GiganetCustomerData[] = this.pgService.getCustomers(sn);
      Logger.log(custDB.length + ' records fetched', 'AppService')
      custDB.forEach(c => {
        resp[c.gpon_serial] = {
          serviceId: c.szolg_id,
          customerId: c.ugyfel_id,
          name: c.ugyfel_nev,
          zipcode: c.irsz,
          city: c.telepulesnev,
          street: c.kozternev + ' ' + c.kozterjelleg,
          houseNum: c.hazszam,
          gpsLatitude: c.szolg_gps_latitude,
          gpsLongitude: c.szolg_gps_longitude,
          ontSn: c.gpon_serial,
          networkNode: c.dist_box
        }
      });
    } catch (err) {
      throw err;
    }
    return resp;
  }
}
